import moment from "moment";
import React from "react";
import {
  Button,
  Card,
  Col,
  Drawer,
  Form,
  Icon,
  notification,
  Row,
  Table,
  Select,
} from "antd";
import _ from "lodash";

import { FormUtils as GetAllFormFields } from "sz-react-utils";
import { hideLoader, showLoader } from "../../modules/actions";
import Request from "../../request";
import { connect } from "react-redux";
import styles from "../../containers/Desk/counselling/all/styles.less";
import { RightsWrapper } from "./utils";
const Option = Select.Option;


const sanitizeValue = (value) => {
  if (!value) return value;

  return value
    // remove markdown mailto if present
    .replace(/\[([^\]]+)\]\(mailto:[^)]+\)/gi, "$1")
    // remove emojis & symbols
    .replace(/[^\p{L}\p{N}\s@.+-]/gu, " ")
    // remove extra spaces
    .replace(/\s+/g, " ")
    .trim();
};

@Form.create()
class SyncFacebookLeads extends React.Component {
  state = {
    visible: true,
    childrenDrawer: true,
    adId: "",
    leads: [],
    arr: [],
    loading: false,
    excelFieldArray: [],
    excelDatas: [],
    DBFieldsArray: [
      "studentName",
      "status",
      "mode",
      "selectInquiryType",
      "dateOfBirth",
      "gender",
      "mobile",
      "watsupp",
      "emailId",
      "facebookEmail",
      "whichYearPlanningToGo",
      "enqType",
      "location",
      "caseHistory",
      "preference",
    ],
    fieldMappingArray: {},
    statusList: "",
    inputTypes: {
      fields: [
        {
          label: "Choose Campaign",
          key: "facebookAdId",
          type: "select",
          required: true,
          options: [],
          onChange: (v) => {
            this.props.form.setFieldsValue({ facebookAdId: v });
            this.getAllAdSets(v);
          },
        },
        {
          label: "Choose AdSet",
          key: "facebookAdSet",
          type: "select",
          required: true,
          width: 500,
          options: [],
          onChange: (v) => {
            this.props.form.setFieldsValue({ facebookAdSet: v });
            this.getAllAds(v);
          },
        },
        {
          label: "Choose Ad",
          key: "facebookAd",
          type: "select",
          required: true,
          width: 500,
          options: [],
          onChange: (v) => {
            this.props.form.setFieldsValue({ facebookAd: v });
            this.setState({
              adId: v,
            });
          },
        },
      ],
    },
  };
  // Getting All Ad Sets
  getAllAdSets = (campaignId) => {
    Request.getFacebookAdSets(campaignId).then((res) => {
      res.data = res.data.reduce((total, val) => {
        total.push({
          _id: val.id,
          key: val.id,
          display: val.name,
        });
        return total;
      }, []);
      let inputTypes = this.state.inputTypes;
      inputTypes.fields[1].options = res.data;
      this.setState({ inputTypes });
    });
  };

  // Getting All Ads
  getAllAds = (adSetId) => {
    Request.getAllAds(adSetId).then((res) => {
      res.data = res.data.reduce((total, val) => {
        total.push({
          id: val.id,
          key: val.id,
          display: val.name,
        });
        return total;
      }, []);
      let inputTypes = this.state.inputTypes;
      inputTypes.fields[2].options = res.data;
      this.setState({ inputTypes });
    });
  };

  getAllLeads = (adId) => {
    let fieldArray = {
      full_name: "studentName",
      city: "address",
      phone_number: "mobile",
      email: "emailId",
      "looking_for_position_?": "appliedFor",
      "preferred_intake_": "whichYearPlanningToGo",
      "highest_qualification": "highest_qualification",
      "phone_number_verified": "mobileVerified",
      "when_are_you_planning_to_study_in_new_zealand": "whichYearPlanningToGo",
      "when_are_you_planning_to_study_in_new_zealand_?": "whichYearPlanningToGo",
      "what_is_your_highest_qualification?": "highest_qualification",
      "_what_is_your_highest_qualification?": "highest_qualification",
      "have_you_taken_ielts_or_pte": "haveEnglishTestScore",
      "have_you_taken_ilets_or_pte?": "haveEnglishTestScore",
      "do_you_have_a_valid_passport_?": "havePassport",
      "do_you_have_a_valid_passport_?": "havePassport"
    };
    Request.getAllLeads(adId).then((res) => {
      let allArray = [];
      res.data.map((item) => {
        let { field_data } = item;

        if (field_data && field_data.length > 0) {
          let data = {};
          field_data.map((field) => {
            let fieldName = fieldArray[field.name];

            if (!fieldName) {
              console.log("Not mapped:", field.name);
            }

            if (fieldName === "mobileVerified") {
              data[fieldName] = JSON.parse(field.values[0].toLowerCase());
            } else {
              data[fieldName] = sanitizeValue(field.values[0]);
            }
          });
          data.mode = "Facebook";
          data.location = "Facebook";
          data.campaignName = item.campaign_name;
          allArray.push(data);
        }
      });
      this.setAllLeads(allArray);
    });
  };

  setAllLeads = async (data) => {
    let x = await Request.setFacebookLeadsData(data);
    if (!x.error) {
      this.onClose();
      notification.success({
        message: x.message,
      });
    } else {
      notification.error({
        message: "Error Saving",
        description: x.message,
      });
    }
  };

  setFieldMaping = (field, fieldKey) => {
    let fieldMappingArray = this.state.fieldMappingArray;
    fieldMappingArray[field] = fieldKey;
    this.setState({ fieldMappingArray: fieldMappingArray });
  };

  submitMapingFields = (e) => {
    const { dispatch, form } = this.props;
    e.preventDefault();
    form.validateFieldsAndScroll(async (err, valData) => {
      let {
        fieldMappingArray,
        excelDatas,
        statusList,
        siteIndex,
        googleSpreadsheetId,
        location,
      } = this.state;
      if (!err) {
        let values = _.clone(valData);
        dispatch(showLoader());

        let x = await Request.setGoogleSpreadsheetData({
          fieldMappingArray,
          statusList,
          siteIndex,
          googleSpreadsheetId,
          location,
        });

        dispatch(hideLoader());

        if (!x.error) {
          this.onClose();
          form.resetFields();
          notification.success({
            message: x.message,
          });
        } else {
          notification.error({
            message: "Error Saving",
            description: x.message,
          });
        }
      }
    });
  };

  componentDidMount() {
    Request.getFacebookCampaigns().then((res) => {
      let data = res.data;
      let inputTypes = this.state.inputTypes;
      if (data) {
        data.map((item) => {
          if (
            item.objective == "OUTCOME_LEADS" ||
            item.objective == "LEAD_GENERATION"
          ) {
            inputTypes.fields[0].options.push({
              id: item.id,
              display: item.name,
            });
          }
        });
        this.setState({ inputTypes });
      }
    });
  }

  onClose = () => {
    this.setState({
      visible: false,
    });

    setTimeout(() => {
      this.props.onClose();
    }, 400);
  };

  handleSubmit = (e) => {
    e.preventDefault();
    this.getAllLeads(this.state.adId);
  };

  render() {
    const {
      form: { getFieldDecorator, getFieldValue },
    } = this.props;
    const {
      excelFieldArray,
      excelDatas,
      DBFieldsArray,
      statusList,
    } = this.state;

    const fieldWidth =
      excelFieldArray.length > 0 ? 900 / excelFieldArray.length : 200;
    return (
      <Drawer
        title={
          <div>
            <React.Fragment>Sync Facebook Inquiry Data</React.Fragment>
          </div>
        }
        placement="right"
        closable={true}
        onClose={this.onClose}
        width={800}
        visible={this.state.visible}
      >
        <Card>
          <Form onSubmit={this.handleSubmit} style={{ marginTop: 8 }}>
            <div>
              <GetAllFormFields
                inputSchema={this.state.inputTypes}
                getFieldDecorator={getFieldDecorator}
              />
            </div>
            <Row>
              <Col span={8} />
              <Col span={8}>
                <Button
                  type="primary"
                  htmlType="submit"
                  style={{ marginBottom: 10 }}
                  loading={this.props.loading}
                >
                  PULL
                </Button>
              </Col>
              <Col span={8} />
            </Row>
          </Form>
        </Card>
        <Card>
          {excelFieldArray && excelFieldArray.length ? (
            <Form onSubmit={this.submitMapingFields} style={{ marginTop: 8 }}>
              <table className="ant-table-fixed">
                <tbody className="ant-table-tbody">
                  {excelFieldArray.map((field, indexExcelFieldArray) => {
                    return (
                      <tr
                        key={indexExcelFieldArray}
                        className="ant-table-row  ant-table-row-hover"
                      >
                        <th
                          className="ant-table-fixed-columns-in-body ant-table-row-cell-break-word"
                          width="300"
                        >
                          {field}
                        </th>
                        <td className="ant-table-fixed-columns-in-body ant-table-column-has-actions ant-table-column-has-filters ant-table-column-has-sorters ant-table-row-cell-break-word">
                          <Select
                            showSearch={true}
                            allowClear
                            optionFilterProp="children"
                            style={{
                              width: 214,
                              paddingRight: 16,
                              paddingLeft: 9,
                            }}
                            placeholder="Select Field"
                            onChange={(fieldKey) => {
                              this.setFieldMaping(field, fieldKey);
                            }}
                          >
                            {DBFieldsArray.map((val, idn) => {
                              return (
                                <Option key={idn} value={val}>
                                  {val}
                                </Option>
                              );
                            })}
                          </Select>
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
              <Row>
                <Col span={8} />
                <Col span={8}>
                  <Button
                    type="primary"
                    htmlType="submit"
                    style={{ marginBottom: 10 }}
                    loading={this.props.loading}
                  >
                    SAVE
                  </Button>
                </Col>
                <Col span={8} />
              </Row>
            </Form>
          ) : null}
        </Card>
        <Card>
          <table className="ant-table-fixed" style={{ textAlign: "center" }}>
            <thead>
              <tr className="ant-table-row  ant-table-row-hover">
                {excelFieldArray && excelFieldArray.length
                  ? excelFieldArray.map((field, indexField) => {
                    return (
                      <th
                        key={indexField}
                        className="ant-table-fixed-columns-in-body ant-table-row-cell-break-word"
                        width={fieldWidth}
                      >
                        {field}
                      </th>
                    );
                  })
                  : null}
              </tr>
            </thead>
            <tbody className="ant-table-tbody">
              {excelDatas && excelDatas.length
                ? excelDatas.map((excelData, indexExcel) => {
                  return (
                    <tr
                      key={indexExcel}
                      className="ant-table-row  ant-table-row-hover"
                    >
                      {excelFieldArray && excelFieldArray.length
                        ? excelFieldArray.map((field, indexExcelField) => {
                          return (
                            <td
                              key={indexExcelField}
                              className="ant-table-fixed-columns-in-body ant-table-column-has-actions ant-table-column-has-filters ant-table-column-has-sorters ant-table-row-cell-break-word"
                            >
                              {excelData[field]}
                            </td>
                          );
                        })
                        : null}
                    </tr>
                  );
                })
                : null}
            </tbody>
          </table>
        </Card>
      </Drawer>
    );
  }
}

const mapStateToProps = ({ global, router }) => ({
  loading: global.buttonLoading,
  search: router.location.search,
});
const mapDispatchToProps = (dispatch) => {
  return {
    dispatch,
  };
};
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(SyncFacebookLeads);
